import { getSignInUrl } from "../middleware/login";
import { trackWebAction } from "../analytics/dataLayer";
import constants from "../constants";
import { ANALYTICS_EVENT_TYPES } from "../constants/analytics";
import storageConstants from "../constants/storage";
import errorConstants from "../constants/error";
import { trackConvivaCustomEvent } from "../analytics/media";
import { setSessionStorage } from "./sessionStorage";
import i18n from "../../i18n.js";
import { DT_ATTRIBUTES, LOGIN_IDP_VALUES, LOGIN_SERVICE_TYPES, EVENT_STATUS_VALUES } from "../constants/dynatrace";
import { getLocalStorage, setLocalStorage } from "./localStorage.js";

const { LOGIN_REDIRECT_URL, LAST_TRENDING_UPCOMING_FETCH, DEVICE_ID } = storageConstants;
const { LOGIN_BRANDS, IN_MARKET_OPTIK_URL, LOGIN_METHODS } = constants;
const { ERROR_MESSAGES, AVS_ERROR_CODES } = errorConstants;

/**
 * Sets the login redirect url in local storage
 * Redirects user to telus identity login
 */
export function handleLogin(
  appProvider,
  loginBrand = LOGIN_BRANDS.TELUS,
  KoodoEnabled = true,
  isDynatraceTrackingEnabled,
  isPanicModeActive
) {
  const signInUrl = getSignInUrl(appProvider, loginBrand, KoodoEnabled);
  trackWebAction(ANALYTICS_EVENT_TYPES.LOGIN_START, signInUrl, null, isDynatraceTrackingEnabled, {
    [DT_ATTRIBUTES.LOGIN_CLIENT_ID]:
      loginBrand === LOGIN_BRANDS.TELUS
        ? appProvider.config.general.AVS_config.clientIdTelus
        : appProvider.config.general.AVS_config.clientIdKoodo,
    [DT_ATTRIBUTES.LOGIN_METHOD]: LOGIN_METHODS.MANUAL,
    [DT_ATTRIBUTES.LOGIN_IDP]: LOGIN_IDP_VALUES.CI_FR,
    [DT_ATTRIBUTES.ACCOUNT_BRAND]: loginBrand.toLowerCase(),
    [DT_ATTRIBUTES.LOGIN_SERVICE_TYPE]: LOGIN_SERVICE_TYPES.HTML,
    [DT_ATTRIBUTES.DEVICE_ID]: getLocalStorage(DEVICE_ID),
    [DT_ATTRIBUTES.EVENT_STATUS]: EVENT_STATUS_VALUES.SUCCESS,
    [DT_ATTRIBUTES.SESSION_PANIC_MODE]: isPanicModeActive ?? false,
  });

  trackConvivaCustomEvent(ANALYTICS_EVENT_TYPES.LOGIN_START, { loginStart: true });
  if (window.location.hash && window.location.hash !== "#/")
    setSessionStorage(LOGIN_REDIRECT_URL, window.location.href);
  setLocalStorage(LAST_TRENDING_UPCOMING_FETCH, Date.now());
  window.location.href = signInUrl;
}

/**
 * Function to map login error to error modal config
 * @returns login error modal map
 */
export function getLoginErrorModalMap() {
  return {
    [ERROR_MESSAGES.MULTI_GEO_ERROR]: {
      className: "invalid-account-modal",
      title: "cookies_subscribed_optik_tv",
      message: "cookies_optiktv_app",
      isCloseable: false,
      buttons: [
        {
          label: i18n.t("cookies_go_optiktv"),
          onClickHandler: () => (window.location.href = IN_MARKET_OPTIK_URL),
        },
      ],
      endButtonLabelOverride: "", // Removes default end button
    },
    [AVS_ERROR_CODES.INACTIVE_ACCOUNT]: {
      title: "error",
      message: "login_error_inactive_account",
      disableRetry: true,
    },
    [AVS_ERROR_CODES.BLOCKED_ACCOUNT]: {
      title: "error",
      message: "login_error_blocked_account",
      disableRetry: true,
    },
    [AVS_ERROR_CODES.UNKNOWN_TOKEN]: {
      title: "error",
      message: "login_error_token_unknown",
      disableRetry: true,
    },
  };
}
